var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "security-statement row justify-content-center m-4 text-secondary"
    },
    [
      _c("font-awesome-icon", {
        staticClass: "lead-channel-primary-color mr-2",
        attrs: { icon: ["fas", "lock"] }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("\n    Your information is secured\n  ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }